import React, { useEffect } from "react";
import { createPortal } from "react-dom";
/**
 * Modal de confirmación (reemplazo de window.confirm).
 * z-[210] por defecto: queda por encima de Modal (z-[200] en apps/web).
 */
export default function ConfirmModal({
    open,
    onClose,
    onConfirm,
    title = "Confirmar",
    message,
    confirmLabel = "Confirmar",
    variant = "danger",
    loading = false,
    zIndexClass = "z-[210]",
}: Record<string, any>): any {
    useEffect((): any => {
        if (!open)
            return undefined;
        const handleEscape = (e: any): any => e.key === "Escape" && onClose?.();
        document.addEventListener("keydown", handleEscape);
        return (): any => document.removeEventListener("keydown", handleEscape);
    }, [open, onClose]);
    if (!open)
        return null;
    if (typeof document === "undefined")
        return null;
    const confirmClass = variant === "danger"
        ? "bg-danger text-fg-on-brand hover:opacity-90 focus:ring-danger"
        : "bg-brand-700 text-fg-on-brand hover:bg-brand-800 focus:ring-brand-500";
    const overlay = (<div className={`fixed inset-0 ${zIndexClass} flex items-center justify-center p-4 animate-in fade-in duration-150`} role="dialog" aria-modal="true" aria-labelledby="confirm-title">
      <div className="absolute inset-0 bg-fg/40 backdrop-blur-sm" onClick={onClose} aria-hidden="true"/>
      <div className="relative w-full max-w-md rounded-modal bg-surface shadow-xl border border-border p-6 animate-in zoom-in-95 duration-150" onClick={(e: any): any => e.stopPropagation()}>
        <h2 id="confirm-title" className="text-lg font-semibold text-fg mb-2">
          {title}
        </h2>
        <p className="text-fg-muted text-sm mb-6">{message}</p>
        <div className="flex justify-end gap-2">
          <button type="button" onClick={onClose} className="rounded-lg border border-border-strong px-4 py-2 text-sm font-medium text-fg-muted hover:bg-surface-sunken focus:outline-none focus:ring-2 focus:ring-border-strong focus:ring-offset-2">
            Cancelar
          </button>
          <button type="button" onClick={onConfirm} disabled={loading} className={`rounded-lg px-4 py-2 text-sm font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 ${confirmClass}`}>
            {loading ? (<span className="inline-flex items-center gap-2">
                <span className="w-3.5 h-3.5 border-2 border-current border-t-transparent rounded-full animate-spin"/>
                Espera...
              </span>) : (confirmLabel)}
          </button>
        </div>
      </div>
    </div>);
    return createPortal(overlay, document.body);
}
